import type { FaireProductEntity } from "../../entity_types/product";

export const p_ebcxuybehk: FaireProductEntity = {
  token: "p_ebcxuybehk",
  type: "product",
  name: "Chocoviar Creme Cacao - Italian Gourmet Chocolate Pieces",
  brandToken: "b_2ajh8bwwaf",
  brandName: "Venchi",
  imageUrl:
    "https://cdn.faire.com/fastly/f3ca1f45c88bc62d3ff7229dc51b4e51dd259f47784f69af10ea3989843df21e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bc4190368baaca6eb461f73877d900bd8d17c93a09e2cfcc201d47fd3ccc224.jpeg",
    "https://cdn.faire.com/fastly/6d3e6e09323acc9bb3a06504fee0d69eccbb19d3eaec3d78fe569bc087475cd4.jpeg",
    "https://cdn.faire.com/fastly/a6451ab05f73befc97bca65c6f711ea3618876a572a06e467cc2473b225d1324.jpeg",
    "https://cdn.faire.com/fastly/1aa30d9babcf4d81225767849212a22c1b8312d94b5b7436f337b0576d4d3cbe.jpeg",
    "https://cdn.faire.com/fastly/89267cfa7f417558278f41f3487279f71f81b65c22e72471d51d3d2417e34e2b.jpeg",
    "https://cdn.faire.com/fastly/7d9a66898aaaa9a52e0f432e3be8b5d01586a08d8e75edb8113dcddbd9f9bb63.jpeg",
  ],
  priceDollars: 57.72,
  description:
    "Venchi's Crema Cacao Filled Extra Dark Chocolate brings together bold cocoa depth and creamy hazelnut richness in a refined, bite-sized format. At the center is a smooth hazelnut filling made with 45% PGI Piedmont Hazelnuts and rich cocoa, wrapped in a milk chocolate shell and finished with a coating of extra dark chocolate and crunchy cocoa nibs. Made in Italy with premium, natural ingredients, this gluten-free chocolate is ideal for retailers seeking a balanced, indulgent option in a convenient bulk format.\n\nKey Features:\n-Filled with hazelnut cocoa cream made from 45% PGI Piedmont Hazelnuts\n-Milk chocolate shell with extra dark chocolate coating & cocoa nibs sprinkles\n-Venchi's Chocoviar Collection\n-Gluten free; crafted with high-quality, natural ingredients\n-48 pieces (2.2 lb/1 kg) bulk bag\n-Made in Italy\n\nAn excellent option for retailers offering hazelnut filled chocolate, gourmet extra dark chocolate, or bulk Italian chocolate with layered textures.",
  tags: [],
  msrpDollars: 128,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:08.943Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
